import React, { useContext, useState, useEffect, useRef } from 'react'
import { Button, Tooltip } from '@mui/material'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
// import {
//     mapData,
//     dateTimeFormatFunction,
//     handleRedirectInternal,
// } from '../../common/components'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import Reorder from 'react-reorder'
import { arrayMoveImmutable } from 'array-move'
import SettingContext from '@/product/context/setting/settingContext'
import DynamicContext from '@/product/context/dynamic/dynamicContext'
import CustomDialog from '@/product/components/organisms/Dialog'
import DropdownValueManage from '@/views/Dynamic/dropdownManage'
import CustomCommonContext from '@/custom/context/common/commonContext'
import Layout from '@/product/components/templates/Layout'
import CustomTable from '@/product/components/molecules/CustomTable'
import authContext from '@/product/context/auth/authContext'
// import './dynamic.css'

const FieldManage = (props) => {
    const settingcontext = useContext(SettingContext)
    const { getGlobalVariable, alldata_all_dropdown, allLocations } =
        useContext(CustomCommonContext)
    const { user } = useContext(authContext)

    const {
        searchTableAction,
        updateConfigColumn,
        searchTableFetch,
        search_fetch_data,
        responseStatus: responseStatusSetting,
        clearResponse: clearResponseCommuncation,
    } = settingcontext

    const dynamiccontext = useContext(DynamicContext)
    const {
        propertyColumnReOrder,
        propertyColumnStatusAction,
        responseStatus: responseStatusDynamic,
    } = dynamiccontext

    const [changeStatus, setChangeStatus] = useState(false)
    const statusRequestPending = useRef(false)

    const changeChangeStatus = () => {
        if (!statusRequestPending.current) {
            setChangeStatus(!changeStatus)
        }
    }

    const [manage, setManage] = useState({
        popup: false,
        status: 'new',
        data: null,
    })
    const toggleFullScreenPopupDrop = (popup, status, data) => {
        if (popup) {
            setManage({ popup, status, data })
        } else {
            setManage({ popup, status: 'new', data: null })
        }

        if (!popup && status == 'new' && data == 0) {
            searchTableFetch(formikFetch.values, 'cigar_source')
        }
    }

    const data = props.data
    const toggleFullScreenPopup = props.function

    const [isLoading, setIsLoading] = useState(false)
    const [reload, setReload] = useState(false)
    const [tableBody, setTableBody] = useState([])
    const [tableBodyInActive, setTableBodyInActive] = useState([])

    const [viewPage, setViewPage] = useState(0)

    const formikSelection = useFormik({
        initialValues: {
            action: '',
            active: 0,
            id: 0,
            user_id: user?.admin_id,
            table: 'cigar_source',
            global_publisher: true,
        },
        onSubmit: async (values) => {
            if (statusRequestPending.current) {
                return
            }
            const { action, ...dataValue } = values
            if (
                action === 'active' ||
                action === 'deactive' ||
                action === 'delete'
            ) {
                dataValue.active =
                    action === 'delete' ? 2 : action === 'active' ? 1 : 0
                dataValue.global_publisher = true
                statusRequestPending.current = true
                try {
                    await searchTableAction(dataValue, false, 'cigar_source')
                } finally {
                    statusRequestPending.current = false
                }
            }
        },
    })

    const onSelectMultiProducts = (id, action) => {
        formikSelection.values.action = action
        formikSelection.values.id = id
        if (
            action === 'active' ||
            action === 'deactive' ||
            action === 'delete'
        ) {
            setChangeStatus(true)
        }
    }

    const formikFetch = useFormik({
        initialValues: {
            page: 1,
            limit: 20,
            orderby: 'cs.id,desc',

            primaryTable: 'cigar_source',
        },
        onSubmit: (values) => {
            setIsLoading(true)
            searchTableFetch(values, 'cigar_source')
        },
    })

    useEffect(() => {
        if (props.name) {
            setTableBody([])
            setIsLoading(true)

            formikFetch.values.page = 1

            searchTableFetch(formikFetch.values, 'cigar_source')
        }
    }, [props.name])

    useEffect(() => {
        if (search_fetch_data) {
            if (
                search_fetch_data.from === 'cigar_source' ||
                search_fetch_data.from === 'searchTableFetch'
            ) {
                setTableBody(
                    search_fetch_data.records.length
                        ? search_fetch_data.records
                        : []
                )
                setIsLoading(false)
            }
        }
    }, [search_fetch_data])

    useEffect(() => {
        if (responseStatusSetting) {
            if (responseStatusSetting.status === 'success') {
                if (responseStatusSetting.from === 'cigar_source') {
                    setChangeStatus(false)
                    toggleFullScreenPopupDrop(false)
                    getGlobalVariable()
                    searchTableFetch(formikFetch.values, 'cigar_source')
                }
            }
        }
    }, [responseStatusSetting])

    useEffect(() => {
        if (responseStatusDynamic) {
            if (responseStatusDynamic.status === 'success') {
                if (
                    responseStatusDynamic.from === 'propertyColumnAction' ||
                    responseStatusDynamic.from === 'propertyColumnStatusAction'
                ) {
                    setChangeStatus(false)
                    toggleFullScreenPopupDrop(false)
                    searchTableFetch(formikFetch.values, 'cigar_source')
                }
            }
        }
    }, [responseStatusDynamic])

    const onClickEdit = (id, secondaryID, type) => {
        toggleFullScreenPopupDrop(true, 'edit', id)
    }

    const tableValues = [
        {
            field: 'id',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'ID',
        },
        {
            field: 'source_value',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'Description',
        },
        {
            field: 'en_label',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'English Text',
        },
        {
            field: 'zh_label',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'Mandarin text',
        },
        {
            field: 'added_by',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'Added By',
        },
        {
            field: 'action',
            type: 'button',
            clickType: 'edit',
            onclick: onClickEdit,
            sort: false,
            firstChild: false,
            disablePadding: false,
            label: 'Action',
            tooltipTitle: 'Edit Cigar Sources',
        },
    ]

    return (
        <>
            {search_fetch_data?.records.length == 0 ? (
                <Button
                    id="add_new_field"
                    className="emptyDropdown"
                    onClick={() => toggleFullScreenPopupDrop(true, 'new', null)}
                >
                    <span className="material-icons">note_add</span>

                    <p>
                        {props.dropDownName
                            ? props.dropDownName
                            : 'Add a new dropdown value'}
                    </p>
                </Button>
            ) : (
                <Button
                    id="add_new_field"
                    variant="outlined"
                    className="addDropBtn"
                    onClick={() => toggleFullScreenPopupDrop(true, 'new', null)}
                >
                    <span className="material-icons">add_circle_outline</span>
                    {props.dropDownName
                        ? props.dropDownName
                        : 'Add a new dropdown value'}
                </Button>
            )}

            <>
                <CustomTable
                    formik={formikFetch.values}
                    tableBody={tableBody}
                    tableValues={tableValues}
                    tableActions={[]}
                    allData={search_fetch_data}
                    isLoading={isLoading}
                    loadingTemplate={'table'}
                    changeTableFunction={searchTableFetch}
                    columnStorageVariable={'cigar_source'}
                />

                <DropdownValueManage
                    data={manage}
                    subLevel={props.subLevel}
                    name={props.name}
                    subField={props.subField}
                    avatar={props.avatar}
                    custom_language={props.custom_language}
                    diff_value={props.diff_value}
                    function={toggleFullScreenPopupDrop}
                    show_order={
                        tableBody.length
                            ? tableBody[tableBody.length - 1].show_order + 1
                            : 1
                    }
                    dropDownName={props.dropDownName || ''}
                    dropDownNameEdit={props.dropDownNameEdit || ''}
                />

                <CustomDialog
                    title={'Change property status'}
                    open={changeStatus}
                    function={changeChangeStatus}
                    disableBackdropClick
                >
                    <h5>
                        {formikSelection.values.action === 'delete'
                            ? 'Are you sure you want to delete'
                            : 'Are you sure you want to change the status'}
                    </h5>
                    <div className="actionWrapper">
                        <Button
                            id="dynamic_cancel"
                            disabled={formikSelection.isSubmitting}
                            onClick={() => changeChangeStatus()}
                        >
                            Cancel
                        </Button>
                        <form
                            onSubmit={formikSelection.handleSubmit}
                            autoComplete="nofill"
                        >
                            <PrimaryButton
                                id="dynamic_field_submit"
                                type="submit"
                                label="Confirm"
                                disabled={formikSelection.isSubmitting}
                            />
                        </form>
                    </div>
                </CustomDialog>
            </>
        </>
    )
}

export default FieldManage
